import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import aircraftSlice from "../features/aircraft/aircraftSlice";
import sessionSlice from "../features/session/sessionSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import missionSlice from "../features/mission/missionSlice";
import {
  displayNotificationMiddleware,
  notificationMiddleware,
  telemetryMiddleware,
  websocketMiddleware,
} from "./middleware";
import airspaceSlice from "../features/airspace/airspaceSlice";

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['session'] // Add any other slices you want to persist
};

const rootReducer = {
  aircraft: aircraftSlice,
  session: sessionSlice,
  mission: missionSlice,
  airspace: airspaceSlice,
};

// Define paths to ignore in state checks
const ignoredPaths = [
  'aircraft',
  'mission',
  'airspace',
  'aircraft.mission',
  'aircraft.geoJson',
  'mission.geoJson',
  'airspace.geofences',
  'airspace.landingZones',
  'airspace.pads'
];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these paths in the state
        ignoredPaths,
        // Increase the warning threshold significantly
        warnAfter: 100,
      },
      immutableCheck: {
        // Ignore these paths in the state
        ignoredPaths,
        // Increase the warning threshold significantly
        warnAfter: 100,
      },
    })
      .prepend(notificationMiddleware.middleware)
      .prepend(displayNotificationMiddleware.middleware)
      .prepend(websocketMiddleware.middleware)
      .prepend(telemetryMiddleware.middleware),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
